/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_ONE_LABEL } from "../graphql";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetOneLabelMethods extends IPluginMethodMap {
  getOneLabel(args: any): Promise<any>;
}

export class GetOneLabelService implements IAgentPlugin {
  readonly methods: IGetOneLabelMethods;

  constructor() {
    this.methods = {
      getOneLabel: this.getOneLabel.bind(this),
    };
  }

  async getOneLabel(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_ONE_LABEL,
          variables: {
            costumeId: args?.costumeID,
          },
          fetchPolicy: "network-only",
        });

        if (res?.data?.getOneLabel && is.existy(res?.data?.getOneLabel)) {
          return res?.data?.getOneLabel;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
